import React, { useState} from "react";
import Edit2Icon from "../../../../ui/svg/common/edit2";
import {IWishList} from "../../interfaces";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";


export interface INewWishlistProps {
    wishlists?: IWishList[] | null,
    hidePopup:()=>void,
    submit:  (newWishlistName:string) => void,
    errorMessage:string
}

/**
 * new wishlist's form
 */
const NewWishlistCommon = (props:INewWishlistProps) => {
    const [newWishlistName, setNewWishlistName] = useState("");
    const [listNameIsEmpty, setListNameIsEmpty] = useState(false);

    const CreateWishList = async () => {
        if(newWishlistName.length === 0){
            setListNameIsEmpty(true);
            return;
        }
        setListNameIsEmpty(false);
        sendGAEvent("Wish List","Create New Wish List");
        await props.submit(newWishlistName);

    }
    return (
        <div className="py-4 w-80">
            <div className="font-bold pb-2">Create a new list</div>
            <div className="flex border-b border-gray-250 w-full mt-4 text-right">
                <div className="w-11/12">
                    <input
                        className="text-sm font-normal text-gray-500 py-2 focus:outline-none w-full  pl-2"
                        value={ newWishlistName }
                        autoComplete="off"
                        type="text"
                        placeholder="New List Name..."
                        onChange={evt => {
                            setNewWishlistName(evt.target.value);
                        }}
                        autoFocus
                        maxLength={30}
                        minLength={1}
                    />
                </div>
                <div className="w-1/12 pt-2">
                    <Edit2Icon width="16px" color="black" />
                </div>
            </div>
            {listNameIsEmpty && <div className="text-red w-full pl-2 text-sm">This field is required.</div>}

            <div className="w-full text-right flex text-center mt-8">
                <button type="button" className="px-4 py-2 cursor-pointer" onClick={props.hidePopup}>Cancel</button>
                <button type="button" className="w-btn inline-block bg-blue-200 text-white font-normal w-auto px-9"
                        onClick={CreateWishList}>
                    <span>Create List</span>
                </button>
            </div>
        </div>
    )
};

export default NewWishlistCommon;